module.exports = __webpack_public_path__ + "img/login_bg.f26e32bf.jpg";